module.exports = __webpack_public_path__ + "static/media/bookmark-check.1235e8a2.svg";